import React, { useMemo } from "react";
import {
  SPECS_LIST,
  DisplayedSpecs,
  Specs,
} from "./SpecsAdditionalDetailsModel";
import {
  ListingCategoryTypes,
  SellerListing,
} from "@/interfaces/listing/SellerListing";

const SpecsAdditionalDetails = ({ listing }: { listing: SellerListing }) => {
  const getDisplayedSpec = (spec: Specs): DisplayedSpecs => {
    const { text, getter } = spec;
    const value = getter(listing) as string;
    return { text, value };
  };

  const getAutoSpecs = () => {
    return [
      getDisplayedSpec(SPECS_LIST.Trim),
      getDisplayedSpec(SPECS_LIST.Cylinders),
      getDisplayedSpec(SPECS_LIST.Vin),
      getDisplayedSpec(SPECS_LIST.Doors),
      getDisplayedSpec(SPECS_LIST.TitleInHand),
      getDisplayedSpec(SPECS_LIST.BodyStyle),
      getDisplayedSpec(SPECS_LIST.ExteriorColor),
      getDisplayedSpec(SPECS_LIST.TitleType),
      getDisplayedSpec(SPECS_LIST.Lien),
    ];
  };

  const getMotorcycleSpecs = () => {
    return [
      getDisplayedSpec(SPECS_LIST.Cylinders),
      getDisplayedSpec(SPECS_LIST.Vin),
      getDisplayedSpec(SPECS_LIST.TitleInHand),
      getDisplayedSpec(SPECS_LIST.PrimaryColor),
      getDisplayedSpec(SPECS_LIST.TitleType),
      getDisplayedSpec(SPECS_LIST.Lien),
    ];
  };

  const getATVSpecs = () => {
    return [
      getDisplayedSpec(SPECS_LIST.Vin),
      getDisplayedSpec(SPECS_LIST.ATVCategory),
      getDisplayedSpec(SPECS_LIST.TitleInHand),
      getDisplayedSpec(SPECS_LIST.ATVPrimaryColor),
      getDisplayedSpec(SPECS_LIST.ATVStarter),
      getDisplayedSpec(SPECS_LIST.Lien),
    ];
  };

  const getSpecs = (listing: SellerListing): DisplayedSpecs[] => {
    let specs;
    switch (listing.vehicleType) {
      case ListingCategoryTypes.Motorcycle:
        specs = getMotorcycleSpecs();
        break;
      case ListingCategoryTypes.ATVOHV:
        specs = getATVSpecs();
        break;
      default:
        specs = getAutoSpecs();
        break;
    }
    return specs;
  };

  const specs = useMemo(() => getSpecs(listing), [listing]);
  const midPoint = useMemo(() => Math.ceil(specs.length / 2), [specs]);
  const [specs1, specs2] = useMemo(
    () => [specs.slice(0, midPoint), specs.slice(midPoint)],
    [specs, midPoint]
  );

  return (
    <div className="block sm:flex text-sm mt-4 space-y-4 sm:space-y-0 ">
      <div className="w-full sm:w-1/2 space-y-4 text-[16px]">
        {specs1.map((detail, index) =>
          detail.value ? (
            <div key={index} className="grid grid-cols-2 pr-0 sm:pr-32">
              <p>{detail.text}</p>
              <p className="font-bold">{detail.value}</p>
            </div>
          ) : null
        )}
      </div>
      <div className="w-full sm:w-1/2 space-y-4 text-[16px]">
        {specs2.map((detail, index) =>
          detail.value ? (
            <div key={index} className="grid grid-cols-2 pr-0 sm:pr-32">
              <p>{detail.text}</p>
              <p className="font-bold">{detail.value}</p>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default SpecsAdditionalDetails;
